module.exports = __webpack_public_path__ + "media/images/diploma-3847fe91e7ec8b11bb886307f6b84633.png";